var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1625 0H11.2524C10.4614 0 9.82025 0.641189 9.82025 1.43214V6.34232C9.82025 7.13326 10.4614 7.77445 11.2524 7.77445H16.1625C16.9534 7.77445 17.5946 7.13326 17.5946 6.34232V1.43214C17.5946 0.641189 16.9534 0 16.1625 0Z",
    fill: "#DA873E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.581 12.695L14.72 9.83395C14.4511 9.56602 14.087 9.41557 13.7074 9.41557C13.3279 9.41557 12.9638 9.56602 12.6949 9.83395L9.83384 12.695C9.56573 12.9638 9.41517 13.3279 9.41517 13.7076C9.41517 14.0872 9.56573 14.4514 9.83384 14.7201L12.6949 17.5812C12.9636 17.8494 13.3278 18 13.7074 18C14.0871 18 14.4512 17.8494 14.72 17.5812L17.581 14.7201C17.8493 14.4515 18 14.0873 18 13.7076C18 13.3279 17.8493 12.9637 17.581 12.695Z",
    fill: "#DA873E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34225 0H1.43212C0.641182 0 0 0.641189 0 1.43214V6.34232C0 7.13326 0.641182 7.77445 1.43212 7.77445H6.34225C7.13318 7.77445 7.77437 7.13326 7.77437 6.34232V1.43214C7.77437 0.641189 7.13318 0 6.34225 0Z",
    fill: "#DA873E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34225 9.82036H1.43212C0.641182 9.82036 0 10.4615 0 11.2525V16.1627C0 16.9536 0.641182 17.5948 1.43212 17.5948H6.34225C7.13318 17.5948 7.77437 16.9536 7.77437 16.1627V11.2525C7.77437 10.4615 7.13318 9.82036 6.34225 9.82036Z",
    fill: "#DA873E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/Other.764fb49685a3373be6a0ebe3f57b6c85.svg";
export { ForwardRef as ReactComponent };